import ReactPaginate from "react-paginate";

interface Props {
  pageCount: number;
  currentPage: number;
  position?: string;
  onPageChange: (selectedItem: { selected: number }) => void;
  className?: string;
}

const Pagination = ({
  currentPage,
  pageCount,
  position = "justify-end",
  onPageChange,
  className = "",
}: Props) => {
  // Don't render if there's only one page
  if (pageCount <= 1) return null;

  return (
    <div className={`${className} w-full`}>
      <ReactPaginate
        previousLabel={"← Previous"}
        nextLabel={"Next →"}
        pageCount={pageCount}
        forcePage={currentPage - 1}
        onPageChange={onPageChange}
        containerClassName={`flex ${position} items-center gap-2 my-3 p-2.5 list-none`}
        pageLinkClassName={
          "flex items-center justify-center w-8 h-8 rounded-md border border-gray-300 hover:bg-gray-100"
        }
        previousLinkClassName={
          "px-3 py-1 rounded-md border border-gray-300 hover:bg-gray-100"
        }
        nextLinkClassName={
          "px-3 py-1 rounded-md border border-gray-300 hover:bg-gray-100"
        }
        disabledLinkClassName={
          "opacity-50 cursor-not-allowed hover:bg-transparent"
        }
        activeLinkClassName={
          "bg-accent text-white border-accent hover:bg-accent/90"
        }
        breakLabel="..."
        breakClassName={"flex items-end"}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default Pagination;
